/* eslint-disable import/no-cycle */
import gql from 'graphql-tag';
import { spacePostTypeGQLFields, } from './space-post-type.fields.js';
export function getSpacePostTypeGQLQuery(fields) {
    return gql `
    query GetSpacePostType(
      $spaceId: ID!
      $postTypeId: ID!
    ) {
      spacePostType(
          spaceId: $spaceId
          postTypeId: $postTypeId
    ) {
        ${spacePostTypeGQLFields(fields)}
      }
    }
  `;
}
export function getSpacePostTypesGQLQuery(fields) {
    return gql `
    query GetSpacePostTypes(
      $after: String
      $before: String
      $limit: Int!
      $offset: Int
      $reverse: Boolean
      $spaceId: ID!
    ) {
      spacePostTypes(
        after: $after
        before: $before
        limit: $limit
        offset: $offset
        reverse: $reverse
        spaceIds: $spaceIds
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            ${spacePostTypeGQLFields(fields)}
          }
        }
        nodes {
          ${spacePostTypeGQLFields(fields)}
        }
      }
    }
  `;
}
export const updateSpacePostTypeGQLMutation = (fields) => gql `
  mutation UpdateSpacePostType($spaceId: ID!, $input: UpdateSpacePostTypeInput!) {
    updatePost(id: $id, input: $input) {
      ${spacePostTypeGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=space-post-types.gql.js.map